import {
  YouTubeIframeFromUrl,
  findVideoPlatform,
  usercentricifyIframe
} from '../../ts/helper';
import { userCentricsConsentGiven } from '../basisCookiebot/userCentrics';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="basis-video-player"]';

/**
 * Friendation component
 */
export const basisVideoPlayer = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  components.forEach((component) => {
    /**
     * Create the iframe element for the video
     */
    const createIframe = () => {
      /** The element containing the video player */
      let iframe: HTMLIFrameElement;

      /**  Video URL */
      const url = component.dataset.url;

      const platform = findVideoPlatform(url);

      switch (platform) {
        case 'vimeo':
          console.error('We do not support Vimeo videos due to accessibility');
          break;

        case 'youtube':
          iframe = YouTubeIframeFromUrl(url);
          break;

        default:
          break;
      }

      usercentricifyIframe(iframe);

      return iframe;
    };

    const wrapper: HTMLElement = component.querySelector('.wrapper');
    const poster: HTMLElement = component.querySelector('.poster');
    const playButton: HTMLButtonElement =
      component.querySelector('.poster-overlay');

    /**
     * Try to play the video
     * @param e Mouse event
     */
    const onClick = (e: MouseEvent) => {
      e.preventDefault();

      // Create the iframe for the video
      wrapper.append(createIframe());

      // Double check the consent, then remove the poster. Don't worry, the video will only start, when the consent is already given
      if (userCentricsConsentGiven('marketing')) {
        poster.remove();
      }
    };

    playButton.addEventListener('click', onClick);
  });
};
